/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.triggerGeofence.internal

import features.triggerGeofence.models.TriggerGeofenceRequest
import features.triggerGeofence.models.TriggerGeofenceResponseModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class TriggerGeofencesServiceImpl : TriggerGeofencesService {

    private val triggerGeofencesRequest = TriggerGeofencesRequest()

    override suspend fun triggerGeofence(
        overrideHeaders : Map<String, String>?,
        triggerGeofenceRequest: TriggerGeofenceRequest    ): Result<TriggerGeofenceResponseModel> {
        return triggerGeofencesRequest.triggerGeofence(
            overrideHeaders = overrideHeaders,
            triggerGeofenceRequest = triggerGeofenceRequest        ).toModel()
    }
}
